import { render, staticRenderFns } from "./PlanoMobile.vue?vue&type=template&id=584a62e5&"
import script from "./PlanoMobile.vue?vue&type=script&lang=js&"
export * from "./PlanoMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports